
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';

import './editor.scss';

export default function Edit({ attributes, setAttributes } ) {
	const { backgroundColor,  content, title } = attributes;
	const blockProps = useBlockProps();

	const onChangeContent = ( newContent ) => {
		setAttributes( { content: newContent } )
	}

	const onChangeTitle = ( newTitle ) => {
		setAttributes( { title: newTitle } )
	}

	
	return (
		<div { ...blockProps } 
			style={ { backgroundColor: backgroundColor } }
		>
		
		<RichText 
				tagName='div' 
				className='title'
				value={ title } 
				onChange={onChangeTitle}
				placeholder={__('This is a title placeholder','hide-or-toggle')}
				/>
		<RichText 
				tagName='div' 
				className='hidden'
				value={ content } 
				onChange={onChangeContent}
				placeholder={__('This is a content placeholder.','hide-or-toggle')}
				/>
			
		</div>
	);
}
